import Markdown from "markdown-to-jsx";
import React from "react";
import styles from './daznBet.module.css';
import { Button } from "../VideoPlayer/VideoPlayer";
import { useMedia } from '../../hooks/useMedia';

export function DaznBetBanner({ data }: any) {
  const { isMobile, isDesktop, isTab } = useMedia();

  return (
    <div className={styles.root}>
      <div className={styles.container}>

        <div className={styles.headerContainer}>

          {data?.title && (
            <Markdown className={styles.title}>{data?.title}</Markdown>
          )}
          {data?.description && (
            <Markdown className={styles.description}>{data?.description}</Markdown>
          )}
        </div>

        <div className={styles.imageContainer}>
          {data?.backgroundImage && (
            <>
              {isMobile && (data?.backgroundImage?.mobile || data?.backgroundImage?.default) && (
                <img
                  src={data?.backgroundImage?.mobile || data?.backgroundImage?.default}
                  alt="Background mobile"
                  className={styles.backgroundImage}
                />
              )}

              {isTab && (data?.backgroundImage?.tablet || data?.backgroundImage?.default) && (
                <img
                  src={data?.backgroundImage?.tablet || data?.backgroundImage?.default}
                  alt="Background tablet"
                  className={styles.backgroundImage}
                />
              )}

              {isDesktop && (data?.backgroundImage?.web || data?.backgroundImage?.default) && (
                <img
                  src={data?.backgroundImage?.web || data?.backgroundImage?.default}
                  alt="Background  desktop"
                  className={styles.backgroundImage}
                />
              )}
            </>
          )}
        </div>

        <div>
          {data?.buttons?.[0]?.label && data?.buttons?.[0]?.action ? (
            <Button
              label={data?.buttons[0]?.label}
              className={styles.buttonStyle}
              onClick={() => data?.buttons[0]?.action()}
            />
          ) : null}
        </div>

      </div>
    </div>
  );
}
